import { SVGProps, Ref, forwardRef } from 'react';

export const BulletOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="m8 4 .275.006c2.607.111 3.597 1.814 3.713 3.62L12 8c0 2-1 4-4 4s-4-2-4-4l.012-.374C4.132 5.758 5.187 4 8 4M5.95 9.854C5.6 9.434 5.4 8.792 5.4 8s.2-1.434.55-1.854C6.263 5.772 6.837 5.4 8 5.4s1.737.372 2.05.746c.35.42.55 1.062.55 1.854s-.2 1.434-.55 1.854c-.313.374-.887.746-2.05.746s-1.737-.372-2.05-.746"
            fill="currentColor"
        />
    </svg>
));
BulletOutlinedSize16Glyph.displayName = 'BulletOutlinedSize16Glyph';
